import React, { useState, useEffect } from "react";
import { Card, Col, Row, Modal } from "react-bootstrap";
import { viewAds } from "../../../common/api";
import { Link, useLocation } from "react-router-dom";
import { ShowToast } from "../../../common/function";
import { format } from "date-fns";
import ConfigApp from "../../../common/config";

export default function ViewAds() {
  const location = useLocation();
  const adsId = location.state.adsId;
  const [adsData, setAdsData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [fullscreenMedia, setFullscreenMedia] = useState(null); // store selected image/video

  const formatDate = (dateString) => {
    return format(new Date(dateString), "yyyy-MM-dd");
  };

  const getAdsData = async () => {
    const token = localStorage.getItem("token");
    const response = await viewAds(token, { adsId });
    if (response.success) {
      setAdsData(response.body);
    } else {
      ShowToast(0, response.message);
    }
  };

  useEffect(() => {
    getAdsData();
  }, []);

  console.log("adsData", adsData);
  const openFullscreen = (mediaUrl, isVideo) => {
    setFullscreenMedia({ url: mediaUrl, isVideo });
    setShowModal(true);
  };

  return (
    <React.Fragment>
      <Card className="mb-3">
        <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
          <h5>Ads Details</h5>
          <Link
            className="btn btn-primary2 d-inline-flex align-items-center justify-content-center px-4 min_width140"
            to="/ads"
          >
            Back
          </Link>
        </Card.Header>

        <Card.Body className="mt-3">
          <div className="taledtl_div">
            <Row>
              <Col md="6">
                <div className="talefile_list">
                  <div className="tablefilelist_grid">
                    <h4>Name</h4>
                    <p>
                      {adsData && adsData?.user?.full_name
                        ? adsData?.user?.full_name
                        : "-"}
                    </p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Start Date</h4>
                    <p>
                      {adsData && adsData?.start_date
                        ? formatDate(adsData?.start_date)
                        : "-"}
                    </p>
                  </div>

                  <div className="tablefilelist_grid">
                    <h4>End Date</h4>
                    <p>
                      {adsData && adsData?.end_date
                        ? formatDate(adsData?.end_date)
                        : "-"}
                    </p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Ad Status</h4>
                    <p className="mt-2">
                      <span
                        className={`badge bg-${
                          adsData && adsData?.status === "approved"
                            ? "success"
                            : adsData && adsData?.status === "rejected"
                            ? "danger"
                            : "warning"
                        }`}
                      >
                        {adsData && adsData?.status == "approved"
                          ? "Approved"
                          : adsData && adsData?.status == "rejected"
                          ? "Rejected"
                          : "Pending"}
                      </span>
                    </p>
                  </div>

                  <div className="tablefilelist_grid">
                    <h4>Ads Expire</h4>
                    <p className="mt-2">
                      <span
                        className={`badge bg-${
                          adsData && adsData?.expired === false
                            ? "success"
                            : adsData && adsData?.expired === true
                            ? "danger"
                            : "warning"
                        }`}
                      >
                        {adsData && adsData?.expired == false
                          ? "Not Expired"
                          : adsData && adsData?.expired == true
                          ? "Expired"
                          : "Pending"}
                      </span>
                    </p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Age Group</h4>
                    <p className="mt-2">
                      <span className="badge bg-info">
                        {adsData?.ageGroup?.min}-{adsData?.ageGroup?.max}
                      </span>
                    </p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Total Amount</h4>
                    <p>${adsData?.amount || 0}</p>
                  </div>
                </div>
              </Col>

              <Col md="6">
                <div className="talefile_list">
                  <div className="tablefilelist_grid">
                    <h4>Goal</h4>
                    <p className="mt-2">
                      <span className="badge bg-primary">
                        {adsData?.goal || "-"}
                      </span>
                    </p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Location</h4>
                    <p>{adsData?.location || "-"}</p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Web Redirection Link</h4>
                    <p className="text-primary">
                      <a
                        href={adsData?.web_link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {adsData?.web_link}
                      </a>
                    </p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Gender</h4>
                    <p>{adsData?.gender || "-"}</p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Interests</h4>
                    <p className="mt-2 d-flex flex-wrap gap-2">
                      {(adsData?.interests || []).map((interest, i) => (
                        <span key={i} className="badge bg-warning">
                          {interest}
                        </span>
                      ))}
                    </p>
                  </div>
                </div>
              </Col>

              <Col md="12">
                <div className="talefile_list">
                  <div className="tablefilelist_grid">
                    <h4>Promotional Images</h4>
                    <div className="d-flex flex-wrap gap-3 mt-2">
                      {(adsData?.post?.media_url || []).map((img, i) => (
                        <div
                          onClick={() =>
                            openFullscreen(
                              ConfigApp.URL + img,
                              img.includes(".mp4")
                            )
                          }
                        >
                          <img
                            key={i}
                            src={ConfigApp.URL + img}
                            alt={`Ad ${i + 1}`}
                            className="rounded border"
                            style={{
                              width: 100,
                              height: 100,
                              objectFit: "cover",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Card.Body>

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="lg"
          centered
          dialogClassName="custom-fullscreen-modal"
        >
          <Modal.Body className=" bg-black position-relative d-flex justify-content-center align-items-center">
            {/* Close Button */}
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: 20,
                right: 20,
                zIndex: 10,
                background: "rgba(0,0,0,0.5)",
                border: "none",
                borderRadius: "50%",
                width: 40,
                height: 40,
                color: "#fff",
                fontSize: 24,
                lineHeight: "40px",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              &times;
            </button>

            {fullscreenMedia?.isVideo ? (
              <video
                src={fullscreenMedia.url}
                controls
                autoPlay
                style={{
                  // maxWidth: "59%",
                  maxHeight: "95vh",
                  borderRadius: 10,
                }}
              />
            ) : (
              <img
                src={fullscreenMedia?.url}
                alt="fullscreen-media"
                className="fullscreen-image"
                style={{
                  width: "100%",
                  borderRadius: 10,
                  height: "400px",
                  objectFit: "contain",
                }}
              />
            )}
          </Modal.Body>
        </Modal>
      </Card>
    </React.Fragment>
  );
}
